<template>
  <default-layout></default-layout>
</template>

<scripts>

</scripts>
<script>
import DefaultLayout from '@/demos/layouts/DefaultLayout'

export default {
  components: {DefaultLayout}
}
</script>
